// eslint-disable-next-line no-use-before-define
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Drawer } from '../../drawer';
import { DrawerContainer, TabsContainer } from './style';
import { DownloadList } from '../download-list';
import useDownloadService from '../hook/use-download-service';
import { FILE_STATUS } from '@cora/download-center';
import { useDownloadCenterPoolingInterval } from '../hook/use-download-center-pooling-interval';
import { COMPLETED_FILE_STATUS } from '../types';
const DownloadDrawer = ({ isOpen, onClose }) => {
    const [activeTab, setActiveTab] = useState('TODOS');
    const { downloadList } = useDownloadService();
    useDownloadCenterPoolingInterval(!isOpen);
    const allStatus = downloadList.filter((download) => download.status !== FILE_STATUS.Removed);
    const processing = downloadList.filter((download) => download.status === FILE_STATUS.Processing);
    const completed = downloadList.filter((download) => COMPLETED_FILE_STATUS[download.status] != null);
    const { t } = useTranslation('drawerDownload');
    return ReactDOM.createPortal(React.createElement(Drawer, { isOpen: isOpen, onClose: onClose, title: t('drawerDownload:title'), description: t('drawerDownload:description') },
        React.createElement(DrawerContainer, null,
            React.createElement("section", { className: "drawer-download_body" },
                React.createElement(TabsContainer, null,
                    React.createElement("div", { className: "tab" },
                        React.createElement("button", { className: `tablinks ${activeTab === 'TODOS' && 'active'}`, onClick: () => setActiveTab('TODOS') }, `${t('drawerDownload:tabAllStatus')} (${allStatus.length})`),
                        React.createElement("button", { className: `tablinks ${activeTab === 'PROCESSANDO' && 'active'}`, onClick: () => setActiveTab('PROCESSANDO') }, `${t('drawerDownload:tabProcess')} (${processing.length})`),
                        React.createElement("button", { className: `tablinks ${activeTab === 'COMPLETO' && 'active'}`, onClick: () => setActiveTab('COMPLETO') }, `${t('drawerDownload:tabCompleted')} (${completed.length})`)),
                    activeTab === 'TODOS' && downloadList && (React.createElement("div", { className: "tabcontent" },
                        React.createElement(DownloadList, { files: allStatus }))),
                    activeTab === 'PROCESSANDO' && (React.createElement("div", { className: "tabcontent" },
                        React.createElement(DownloadList, { files: processing }))),
                    activeTab === 'COMPLETO' && (React.createElement("div", { className: "tabcontent" },
                        React.createElement(DownloadList, { files: completed }))))))), document.getElementById('root-app_side_content'));
};
export { DownloadDrawer };
//# sourceMappingURL=index.js.map